module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-2700.de3a486c.svg";